import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { Login } from './pages/Login.js';
import { DevicePlaneOverview } from './pages/DevicePlaneOverview.js';
import { DevicePlaneLiveStatus } from './pages/DevicePlaneLiveStatus.js';
import { DevicePlaneFleet } from './pages/DevicePlaneFleet.js';
import { DevicePlaneDevice } from './pages/DevicePlaneDevice.js';
import { DevicePlaneCommands } from './pages/DevicePlaneCommands.js';
import { DevicePlaneSensors } from './pages/DevicePlaneSensors.js';
import { DevicePlanePipeline } from './pages/DevicePlanePipeline.js';
import { DevicePlaneConnections } from './pages/DevicePlaneConnections.js';
import { DevicePlaneHealth } from './pages/DevicePlaneHealth.js';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/device-plane" replace />} />
          <Route path="/device-plane" element={<DevicePlaneOverview />} />
          <Route path="/device-plane/status" element={<DevicePlaneLiveStatus />} />
          <Route path="/device-plane/fleet" element={<DevicePlaneFleet />} />
          <Route path="/device-plane/fleet/:deviceId" element={<DevicePlaneDevice />} />
          <Route path="/device-plane/commands" element={<DevicePlaneCommands />} />
          <Route path="/device-plane/sensors" element={<DevicePlaneSensors />} />
          <Route path="/device-plane/pipeline" element={<DevicePlanePipeline />} />
          <Route path="/device-plane/connections" element={<DevicePlaneConnections />} />
          <Route path="/device-plane/health" element={<DevicePlaneHealth />} />
          <Route path="*" element={<Navigate to="/device-plane" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}
